/*
 * Description:
 * Author: zhanghj
 * Date: 2020-09-28 09:38:14
 * LastEditors: zhanghj
 * LastEditTime: 2021-01-07 14:18:48
*/
import React, { Component, Fragment } from 'react';
import Header from 'components/Header';
import styles from './index.less';

class Step extends Component {
  download = () => {
    window.location.href = 'http://m.dragonpass.com.cn/d/'
  }

  render() {
    return (
      <Fragment>
        <Header title="使用记录" />

        <div className="innerContent" style={{ background: '#fff' }}>
          <img className={styles.step} src={require('images/step.jpg')} alt="" />
          <img className={styles.stepBtn} src={require('images/step_btn.png')} alt="" onClick={this.download} />
        </div>
      </Fragment>
    );
  }
}

export default Step;
